import { render, staticRenderFns } from "./MediaCreateDialog.vue?vue&type=template&id=0280f36e&scoped=true"
import script from "./MediaCreateDialog.vue?vue&type=script&lang=js"
export * from "./MediaCreateDialog.vue?vue&type=script&lang=js"
import style0 from "./MediaCreateDialog.vue?vue&type=style&index=0&id=0280f36e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0280f36e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0280f36e')) {
      api.createRecord('0280f36e', component.options)
    } else {
      api.reload('0280f36e', component.options)
    }
    module.hot.accept("./MediaCreateDialog.vue?vue&type=template&id=0280f36e&scoped=true", function () {
      api.rerender('0280f36e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/MediaCreateDialog.vue"
export default component.exports